import { FC } from "react";
import { AppMenuSection } from "../../../../../../../common/routesUtils";
import MultipleRoutes from "./MultipleRoutes";
import SingleRoute from "./SingleRoute";

interface Props {
	menuIsOpen: boolean;
	item: AppMenuSection;
}

/**
 * NavigationItem renders a single item of the application side menu.
 *
 * @param menuIsOpen this flag is used to correctly render the menu item
 * @param item       the section (and its route) represented by the menu item
 * @returns          an item of the application side menu
 */
const NavigationItem: FC<Props> = ({ menuIsOpen, item }) => {
	return item.items.length > 1 ? (
		<MultipleRoutes menuIsOpen={menuIsOpen} item={item} />
	) : (
		<SingleRoute menuIsOpen={menuIsOpen} item={item} />
	);
};

export default NavigationItem;
